'use strict';

angular.module('directives.resize', [])

.directive('resize', function ($window) {
   return function (scope) {
        scope.width = $window.innerWidth;
        scope.height = $window.innerHeight;

        angular.element($window).bind('resize', function () {
            scope.$apply(function () {
                scope.width = $window.innerWidth;
                scope.height = $window.innerHeight;
            });
        });
    };
});
